// roleHelpers.js
const allowedRoles = ['admin', 'super_admin'];

/**
 * Check if a given role is allowed (case-insensitive)
 * @param {string} role - user role string
 * @returns {boolean} true if role is allowed
 */
export const checkAdmin = (role) => {
  if (!role) return false; // guard against null/undefined
  return allowedRoles.includes(role.toLowerCase());
};
